import classNames from 'classnames';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import { mastercard, visacard } from 'data/weraise-data/image-data';
import React, { useState } from 'react';
import { Button, Card, Col, Form, Image, Row } from 'react-bootstrap';
import ReactSelect from 'react-select';

const PNPaymentOption = () => {
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [selectedCard, setSelectedCard] = useState(1);

  const [val, setVal] = useState('');
  const [date, setDate] = useState('');

  const onChange = e => {
    setVal(e.target.value);
  };

  const paymentMethodOptions = [
    { value: '1', label: 'Credit Card' },
    { value: '2', label: 'Visa Card' },
    { value: '3', label: 'Master Card' },
    { value: '4', label: 'MX Card' },
    { value: '5', label: 'Nexus Pay' }
  ];

  const cardOptions = [
    { id: 1, type: mastercard, last4digit: '5678', selected: true },
    { id: 2, type: visacard, last4digit: '1234', selected: false }
  ];

  function cc_format(value) {
    const v = value
      .replace(/\s+/g, '')
      .replace(/[^0-9]/gi, '')
      .substr(0, 16);
    const parts = [];

    for (let i = 0; i < v.length; i += 4) {
      parts.push(v.substr(i, 4));
    }

    return parts.length > 1 ? parts.join(' ') : value;
  }

  function formatExpirationDate(e) {
    // Remove any non-digit characters
    const sanitizedDate = e.target.value?.replace(/\D/g, '');

    // Extract the month and year
    const month = sanitizedDate.slice(0, 2);
    const year = sanitizedDate.slice(2, 4);

    // Return the formatted date
    setDate(`${month}/${year}`);
  }

  return (
    <Card>
      <Card.Header className="pb-0">
        <Card.Title className="fw-medium">Payment</Card.Title>
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label>Select Payment Method</Form.Label>
          <ReactSelect
            closeMenuOnSelect={true}
            options={paymentMethodOptions}
            placeholder="Select Payment Method"
            classNamePrefix="react-select"
            value={paymentMethod}
            onChange={value => setPaymentMethod(value)}
          />
          <Form.Control.Feedback type="invalid">Required</Form.Control.Feedback>
        </Form.Group>
        <Row className="g-3 mb-3">
          {cardOptions?.map(card => (
            <Col key={card.id} md={6}>
              <Flex
                justifyContent="center"
                alignItems="start"
                direction="column"
                className={classNames('border rounded-2 p-3 cursor-pointer', {
                  'border-primary': card.id === selectedCard
                })}
                style={{ height: '100px' }}
                onClick={() => setSelectedCard(card.id)}
              >
                <Image src={card.type} className="mb-2" />
                <p className="mb-0 fs-0 fw-semi-bold">
                  **** **** **** {card.last4digit}
                </p>
              </Flex>
            </Col>
          ))}
        </Row>
        <IconButton icon="plus" variant="link" className="p-0">
          Add new card
        </IconButton>
        <Card className="shadow-none border mt-3">
          <Card.Body className="pb-1">
            <Row className="g-3">
              <Form.Group as={Col} md={12} controlId="Name_On_Card">
                <Form.Label>Name On Card</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Full Name Here"
                />
                <Form.Control.Feedback type="invalid">
                  Name required
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md={12} controlId="CARD_NUMBER">
                <Form.Label>CARD NUMBER</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="0000 0000 0000 0000"
                  value={cc_format(val)}
                  onChange={onChange}
                />
                <Form.Control.Feedback type="invalid">
                  CARD NUMBER required
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md={6} controlId="EXP_DATE">
                <Form.Label>EXP DATE</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="MM/YY"
                  value={date}
                  onChange={formatExpirationDate}
                />
                <Form.Control.Feedback type="invalid">
                  EXP DATE required
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md={6} controlId="CVV">
                <Form.Label>CVV</Form.Label>
                <Form.Control required type="text" placeholder="123" />
                <Form.Control.Feedback type="invalid">
                  CVV required
                </Form.Control.Feedback>
              </Form.Group>
              <Col>
                <Form.Check
                  type="checkbox"
                  id="Save_This_Card"
                  label="Save This Card"
                  defaultChecked
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <Button className="w-100 py-3 mt-3">PAY NOW</Button>
      </Card.Body>
    </Card>
  );
};

export default PNPaymentOption;
